/**
 * Module manifest registration.
 *
 * Apps call `registerManifests()` once at bootstrap, after data-access
 * providers and entity descriptors are set up. Each module that exposes
 * configurable parameters registers its manifest (and optional rules) here.
 */
import { moduleManifestRegistry } from '../services/moduleManifestRegistry.js';
import { technicalSheetManifest } from './technicalSheet.manifest.js';
import { technicalSheetRules } from './technicalSheet.rules.js';
import { receivingManifest } from './receiving.manifest.js';
import { volumeReconcileManifest } from './volumeReconcile.manifest.js';
import { volumeReconcileRules } from './volumeReconcile.rules.js';
import { guidedTechnicalSheetManifest } from './guidedTechnicalSheet.manifest.js';
export function registerManifests() {
    moduleManifestRegistry.register(technicalSheetManifest, technicalSheetRules);
    moduleManifestRegistry.register(receivingManifest);
    moduleManifestRegistry.register(volumeReconcileManifest, volumeReconcileRules);
    moduleManifestRegistry.register(guidedTechnicalSheetManifest);
}
export { technicalSheetManifest } from './technicalSheet.manifest.js';
export { technicalSheetRules } from './technicalSheet.rules.js';
export { receivingManifest, RECEIVING_STEP_OPTIONS, RECEIVING_ALL_STEPS, } from './receiving.manifest.js';
export { volumeReconcileManifest, VOLUME_RECONCILE_DEFAULT_SCAN_LIMIT, VOLUME_RECONCILE_MAX_SCAN_LIMIT, } from './volumeReconcile.manifest.js';
export { volumeReconcileRules } from './volumeReconcile.rules.js';
export { guidedTechnicalSheetManifest, } from './guidedTechnicalSheet.manifest.js';
//# sourceMappingURL=index.js.map